module.exports = __webpack_public_path__ + "static/media/expand-sidebar.119dfe39.svg";